module.exports = __webpack_public_path__ + "static/media/img19.ff3a80c9.JPG";